import Feedback, {
	Metadata
} from '@infinitaslearning/module-il-feedback-widget';
import { Box, Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getBusinessUnit } from '../../../utils/business.utils';
import FeedbackIcon from '@mui/icons-material/Announcement';
import { getJwtToken } from '@infinitaslearning/il.authentication.avatar';
import { config } from '../../../config';
import { Body1 } from '../../atoms';

import './content-feedback.styles.scss';
import { useUserObject } from '../../../hooks/useUserObject';

export type FeedbackProps = {
	metadata: Metadata;
};

export const ContentFeedback: FC<FeedbackProps> = ({
	metadata
}: FeedbackProps) => {
	const { t } = useTranslation('feedback');
	const { userEmail } = useUserObject();
	const businessUnit = getBusinessUnit();

	const collectMetadata = async (): Promise<Metadata> => {
		return { ...metadata };
	};

	return (
		<Box className="content-feedback">
			<Feedback
				customButton={
					<IconButton color="primary">
						<FeedbackIcon sx={{ marginRight: 1 }} />
						<Typography variant="button">{t('button')}</Typography>
					</IconButton>
				}
				feedbackServiceUrl={config.feedbackServiceUrl}
				opco={businessUnit}
				segment="Secondary"
				tokenProvider={getJwtToken}
				userEmail={userEmail}
				collectMetadata={collectMetadata}
				selectDisplayEmpty
				texts={{
					feedbackButtonText: t('button'),
					confirmationClose: t('confirmationClose'),
					confirmationMessage: t('confirmationMessage'),
					confirmationTitle: t('confirmationTitle'),
					sendFailureMessage: t('sendFailureMessage'),
					sendFailureTitle: t('sendFailureTitle'),
					feedbackModalTexts: {
						category: t('category'),
						feedbackTypes: [
							{
								key: 'Content',
								text: t('contentIssue')
							},
							{
								key: 'Answer',
								text: t('answerIssue')
							},
							{
								key: 'CantFinish',
								text: t('cantFinish'),
								component: (
									<Body1>
										{t('technicalTicketExplanation')}
									</Body1>
								)
							},
							{
								key: 'AnswerNotStored',
								text: t('answerNotStored'),
								component: (
									<Body1>
										{t('technicalTicketExplanation')}
									</Body1>
								)
							},
							{
								key: 'ContentNotLoading',
								text: t('contentNotLoading'),
								component: (
									<Body1>
										{t('technicalTicketExplanation')}
									</Body1>
								)
							},
							{
								key: 'Other',
								text: t('otherIssue'),
								component: (
									<Body1>
										{t('contactInformation1')}
										<a href="https://www.noordhoff.nl/klantenservice">
											{' '}
											noordhoff.nl/klantenservice{' '}
										</a>
										{t('contactInformation2')}
									</Body1>
								),
								hideForm: true
							}
						],
						optIn: t('optIn'),
						invalidEmail: t('invalidEmail'),
						describeError: t('describeError'),
						description: t('description'),
						pickCategory: t('pickCategory'),
						privacy: {
							policy1: t('policy1'),
							policy2: t('policy2'),
							policy3: t('policy3'),
							url: 'https://www.noordhoff.nl/privacy'
						},
						confirmDialogTexts: {
							confirmationLabel: t('submit'),
							description: t('information'),
							title: t('header'),
							rejectLabel: t('cancel')
						}
					}
				}}
			/>
		</Box>
	);
};
